/**
 * @file index.tsx
 *
 * @fileoverview Renders password input with show
 *  and hide password options.
 */
import React, { useState } from "react";
import EyeIcon from "@jq-icons/Eye";
import EyeCrossedIcon from "@jq-icons/EyeCrossed";
import { InputProps, Input } from "./../";

export const PasswordInput = React.forwardRef<HTMLInputElement, InputProps>(
  (props: Omit<InputProps, "Icon" | "iconPosition">, ref) => {
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const iconProps = {
      width: "20px",
      height: "20px",
      color: "gray6",
    };

    return (
      <Input
        {...props}
        ref={ref}
        type={showPassword ? "text" : "password"}
        iconPosition="end"
        Icon={
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setShowPassword(!showPassword);
            }}
          >
            {showPassword ? (
              <EyeCrossedIcon {...iconProps} />
            ) : (
              <EyeIcon {...iconProps} />
            )}
          </button>
        }
      />
    );
  }
);
